import * as React from 'react';
import { renderAsync } from 'docx-preview';
import { cn } from '@ai-content-hub/content-kit';
import { getElementUITranslations } from '../../i18n/elementUI';

export interface DocxPreviewViewerProps {
    data: ArrayBuffer;
    className?: string;
}

export const DocxPreviewViewer: React.FC<DocxPreviewViewerProps> = ({ data, className }) => {
    const containerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const el = containerRef.current;
        if (!el) {
            return undefined;
        }

        el.innerHTML = '';

        let cancelled = false;

        void renderAsync(data, el, undefined, {
            className: 'office-docx-preview-doc',
            inWrapper: true,
            breakPages: true,
            ignoreFonts: false,
        })
            .then(() => {
                if (cancelled) {
                    el.innerHTML = '';
                }
            })
            .catch(() => {
                if (!cancelled) {
                    el.innerHTML =
                        `<p class="office-docx-preview-error text-sm text-muted-foreground">${getElementUITranslations().cannotRenderWord}</p>`;
                }
            });

        return () => {
            cancelled = true;
            el.innerHTML = '';
        };
    }, [data]);

    return (
        <div
            className={cn(
                'office-docx-viewer docx-viewer-root max-h-full min-h-0 overflow-auto bg-background p-4',
                className
            )}
            ref={containerRef}
        />
    );
};
